//store/modules/auth.js

import axios from 'axios';
const state = {
  user: null,
  isAuthenticated: false
};
const getters = {
  StateUser: state => state.user,
  isAuthenticated: state => !!state.user
};
const actions = {
  async LogIn({commit}, user) {
    let loggedUser = null
    await axios.post('authentification', user)
    .then(res => {
      loggedUser = res.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
    
    await commit('setUser', loggedUser)
  },
  async LogOut({commit}){
    let user = null
    await commit('logOut', user)
    
    await axios.delete('authentification/deconnexion')
  }
};
const mutations = {
  setUser(state, user){
    state.user = user
  },
  logOut(state, user){
    state.user = user
    state.isAuthenticated = false
  },
};
export default {
  state,
  getters,
  actions,
  mutations
};
